import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function CTASection() {

	return (
		<div className="flex flx-col font-sans justify-center items-center my-8">
			<Link
			to="/signup"
			className="px-12 py-2 rounded-xl bg-sky-300 text-black font-medium hover:bg-sky-400 transition border border-sky-700 hover:border-sky-800"
			>
			Sign Up
			</Link>		
		</div>
	);
}
